/* eslint-disable consistent-return */
import { NAMESPACE } from '@ezugi/constants';

const getInvalidPutParamsError = (key) => `Invalid parameters to put, (${key}, undefined)`;

const getNotFoundError = (k) => `Not Found [${k}]`;

const _notFound = (k) => {
  const err = new Error(getNotFoundError(k));
  err.notFound = true;
  err.key = k;
  return err;
};

/**
 * We need to check if sessionStorage access is supported
 */
const canUseSessionStorage = () => {
  const key = '__TEST_SESSION_STORAGE__';
  try {
    window.sessionStorage.setItem(key, '1');
    window.sessionStorage.getItem(key);
    window.sessionStorage.removeItem(key);
    return true;
  } catch (_) {
    return false;
  }
};

export class SessionStorage {

  constructor(namespace) {
    this._namespace = namespace;
    this._store = canUseSessionStorage() ? window.sessionStorage : {};
    this._sep = '___';
  }

  static clear() {
    try {
      this._store.clear();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }

  get(key) {
    const k = [ this._namespace, key ].join(this._sep);
    if (!this._store[k]) return [ _notFound(k) ];

    try {
      return [ null, JSON.parse(this._store[k]) ];
    } catch (err) {
      return [ err ];
    }
  }

  put(key, value) {
    if (typeof value === 'undefined') {
      return [ new Error(getInvalidPutParamsError(key)) ];
    }

    try {
      const k = [ this._namespace, key ].join(this._sep);
      const v = JSON.stringify(value);
      const result = (this._store[k] = v);
      return [ null, result ];
    } catch (err) {
      return [ err ];
    }
  }

  has(key) {
    const k = [ this._namespace, key ].join(this._sep);
    if (!this._store[k]) return [ _notFound(k) ];
    return [ null, true ];
  }

  del(key) {
    if (key) {
      const k = [ this._namespace, key ].join(this._sep);
      if (!this._store[k]) return [ _notFound(k) ];

      delete this._store[k];
      return [ null ];
    }

    Object.keys(this._store).forEach((k) => {
      const ns = k.split(this._sep)[0];
      if (ns === this._namespace) {
        delete this._store[k];
      }
    });
  }

  search(pattern) {
    if (!pattern) {
      throw new Error('A pattern is required');
    }

    const matchKeys = (key) => {
      const [ , _key ] = key.split(this._sep);

      if (!_key) return;
      if (!pattern.test(_key)) return;

      return key;
    };

    const makePairs = (key) => ({
      key: key.split(this._sep)[1]?.replace('_', ''),
      value: this._store[key],
    });

    return [ null, Object.keys(this._store).filter(matchKeys).map(makePairs) ];
  }

}

export default new SessionStorage(NAMESPACE);
